/**
 * ChatInput - Input area for Deborah Chat
 */
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { 
  Send, 
  Loader2, 
  Phone,
  RefreshCw
} from 'lucide-react';

const ChatInput = ({
  session,
  connectionStatus,
  inputValue,
  setInputValue,
  sending,
  loading,
  onSend,
  onReconnect,
  onInitChat,
  onEscalate,
  messagesCount
}) => {
  
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <>
      {/* Quick Actions */}
      {session && session.status === 'active' && messagesCount > 2 && (
        <div className="px-4 py-2 border-t border-border bg-background">
          <Button
            variant="ghost"
            size="sm"
            onClick={onEscalate}
            className="text-xs text-muted-foreground hover:text-foreground"
            disabled={loading || connectionStatus !== 'connected'}
          >
            <Phone className="w-3 h-3 mr-1" />
            Talk to Human Support
          </Button>
        </div>
      )}

      {/* Input Area */}
      <div className="p-4 border-t border-border bg-background">
        {session?.status === 'resolved' ? (
          <Button 
            onClick={onInitChat} 
            className="w-full rounded-xl"
            disabled={loading}
          >
            {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
            Start New Conversation
          </Button>
        ) : connectionStatus === 'disconnected' ? (
          <Button 
            onClick={onReconnect} 
            variant="outline"
            className="w-full rounded-xl"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Reconnect
          </Button>
        ) : (
          <div className="flex gap-2">
            <Input
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder={
                !session ? "Connecting..." :
                sending ? "Sending..." :
                "Type your message..."
              }
              disabled={sending || loading || !session || connectionStatus !== 'connected'}
              className="rounded-xl"
              data-testid="chat-input"
            />
            <Button
              onClick={onSend}
              disabled={!inputValue.trim() || sending || loading || !session || connectionStatus !== 'connected'}
              className="rounded-xl px-4"
              data-testid="send-button"
            >
              {sending ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <Send className="w-4 h-4" />
              )}
            </Button>
          </div>
        )}
        
        {/* Connection warning */}
        {connectionStatus === 'reconnecting' && (
          <p className="text-xs text-amber-600 text-center mt-2">
            Reconnecting to server...
          </p>
        )}
      </div>
    </>
  );
};

export default ChatInput;
